<template>
    <div class="newsletter-action__content__interaction__scroll-container">
        <div class="newsletter-action__content__padding-correction">
            <div
                class="newsletter-action__content__step newsletter-action__content__step__first-slide"
            >

               <h2 class="newsletter-heading" v-html="helpers.getTranslation(translations, 'subscribe-intro-title')"></h2>

                <span>
                    {{ helpers.getTranslation(translations, 'subscribe-intro-description') }}
                    {{ helpers.getTranslation(translations, 'subscribe-intro-cta') }}
                </span>

                <br />

                <div class="form-group">
                    <label
                        class="text-input__label"
                        for="newsletter-widget__email"
                    >{{ helpers.getTranslation(translations, 'subscribe-email') }}</label>

                    <input
                        type="email"
                        v-model="form.email"
                        class="form-control text-input__input"
                        id="newsletter-widget__email"
                        :placeholder="helpers.getTranslation(translations, 'subscribe-email-error-message')"
                        required
                    />

                    <span v-html="getError('email')"></span>
                </div>

                <button
                    @click="subscribe()"
                    v-bind:disabled="buttonClicked"
                    class="btn btn-primary"
                    v-bind:class="{ loading: buttonClicked }"
                >
                    <span>
                        {{ helpers.getTranslation(translations, 'subscribe-submit') }}
                    </span>
                    <span
                        class="icon-arrow"
                    >
                        <img src="/site/img/arrow_3.svg" alt />
                    </span>
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import helpers from "assets/js/site/helpers";

export default {
    data: () => ({
        form: {
            email: ""
        },
        helpers: helpers,
        errors: {},
        buttonClicked: false
    }),

    methods: {
        subscribe: function() {
            this.buttonClicked = true;
            const self = this;

            axios
                .post("/api/v1/newsletter/subscribe", this.form)
                .then(function(response) {
                    self.$emit("set-email", self.form.email);
                    self.$emit("change-component", {
                        slide_name: "preferences"
                    });
                })
                .catch(function(error) {
                    self.buttonClicked = false;

                    self.errors = error.response.data.errors;

                    console.dir(error);
                });
        },

        getError: function(key) {
            if (!this.errors[key]) return;

            const message = this.helpers.getTranslation(
                this.translations,
                this.errors[key][0]
            );
            return `<p class="error-message" >${message}</p>`;
        }
    },

    props: {
        translations: { required: true }
    }
};
</script>

<style lang="scss">
.newsletter-action__content__step__first-slide {
    .form-group span {
        padding: 0;
        position: absolute;
        top: 60px;

        .error-message {
            font-size: 0.7em !important;
            margin: 0 0 1.5em 0 !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/newsletter-widget/subscribe-slide.vue